import { render, staticRenderFns } from "./LOBSettings.vue?vue&type=template&id=3d230548&"
import script from "./LOBSettings.vue?vue&type=script&lang=js&"
export * from "./LOBSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports